var App = App || {};

App.SmartAppBanner = (function ($) {
    'use strict';

    function Init() {

        new SmartBanner({
            daysHidden: 15,
            daysReminder: 90,
            appStoreLanguage: 'us',
            title: 'American Eagle FCU Mobile',
            author: 'American Eagle FCU Mobile Banking',
            button: 'View',
            store: {
                ios: 'On the App Store',
                android: 'In Google Play'
            },
            price: {
                ios: 'Free',
                android: 'Free'
            }
        });

        var $smartbanner = $(".smartbanner"),
            $smartbannerButton = $smartbanner.find(".smartbanner-button"),
            $smartbannerClose = $smartbanner.find(".smartbanner-close");

        $smartbanner
            .prependTo("body");

        $smartbannerButton
            .addClass("btn btn-sm btn-primary-blue btn-undecorated me-3 p-1 px-2")
            .removeClass("smartbanner-button")
            .children("span")
            .removeClass("smartbanner-button-text");

        $smartbannerClose
            .addClass("btn btn-close")
            .removeClass("smartbanner-close")
            .html("<span class=\"fa-light fa-times\"></span>");
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.SmartAppBanner.Init();
});